// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Percent20 from './Percent20';
import Percent20Circle from './Percent20Circle';
import Percent24 from './Percent24';
import Percent24Circle from './Percent24Circle';
import Percent40 from './Percent40';
import Percent48 from './Percent48';

type PercentProps = {
    variation: '20' | '20Circle' | '24' | '24Circle' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Percent20,
    Percent20Circle,
    Percent24,
    Percent24Circle,
    Percent40,
    Percent48,
};

const Percent: FC<PercentProps> = ({ variation, ...props }) => {
    const variationKey = `Percent${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Percent" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Percent;
